<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dBgpx7/tc-custom/9781571208804.jpg?1704299963730" alt="This image is the cover for the book 250 Continuous-Line Quilting Designs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">250 Continuous-Line Quilting Designs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover how to add beauty, texture, and special meaning to your quilt projects with this wonderful collection of continuous-line quilting designs.</b><br/><br/> Laura is back with another collection of brand new continuous-line quilting designs that are sure to please! These creative, continuous-line designs are perfect for all machines-domestic, mid-arm, and longarm. Mix and match Laura Lee Fritz’s unique images to personalize your quilts. People, animals, nature, sports, and more. There is something here for everyone. A variety of design motifs can be grouped to tell a story, which will give you plenty of ideas for adding special meaning to every quilt you make. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Lee Fritz
      </h2>
      
      <p class="authorDescription body article">Laura Lee Fritz Bio:  Laura Lee Fritz is renowned for her fanciful whole-cloth quilting and has added the finishing touch of fabulous machine quilting for many top quilt artists.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?259ed380